export const environment = {
  "urls": {
    "apiUrl": "http://localhost:5500",
    "botApiUrl": "https://demo.tscti.com/",
  },
};
